import { render, staticRenderFns } from "./RiskAnalysisClient.vue?vue&type=template&id=329b58a7"
import script from "./RiskAnalysisClient.vue?vue&type=script&lang=js"
export * from "./RiskAnalysisClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports